// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"321":"6785f497","606":"5f2afdb2"}[chunkId] + ".chunk.css";
};